// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"course-card-skeleton-group_skeleton__BkhxU","title":"course-card-skeleton-group_title__x9jZB","row":"course-card-skeleton-group_row__z2Fqs"};